import { useEffect, useRef, useState } from "react";
import Image from "next/image";

declare global {
  interface Window {
    Vimeo: any;
  }
}

const VIMEO_VIDEO_ID = "1117395768";

const VideoCard = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const playerRef = useRef<any>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !iframeRef.current) return;

    const initPlayer = () => {
      playerRef.current = new window.Vimeo.Player(iframeRef.current);
    };

    if (typeof window.Vimeo === "undefined") {
      const script = document.createElement("script");
      script.src = "https://player.vimeo.com/api/player.js";
      script.async = true;
      script.onload = initPlayer;
      document.head.appendChild(script);
    } else {
      initPlayer();
    }

    return () => {
      playerRef.current?.destroy();
    };
  }, []);

  const handlePlayVideo = () => {
    if (!playerRef.current) return;
    setIsFading(true);
    setTimeout(async () => {
      await playerRef.current.play();
      setIsPlaying(true);
    }, 500);
  };

  return (
    <div className="flex flex-col w-full max-w-[400px] mx-auto lg:mx-0  justify-between xl:justify-normal">
      <div className="relative aspect-square lg:aspect-video w-full bg-gray-100 self-start min-h-[300px]">
        <div
          style={{
            position: "absolute",
            borderBottomWidth: 2,
            borderColor: "white",
            marginTop: "7%",
            width: "80%",
            marginLeft: "15%",
          }}
        />
        <div
          className="hidden lg:block"
          style={{
            position: "absolute",
            borderBottomWidth: 2,
            borderColor: "white",
            marginTop: "72%",
            width: "80%",
            marginLeft: "15%",
          }}
        />
        <div
          className="block lg:hidden"
          style={{
            position: "absolute",
            borderBottomWidth: 2,
            borderColor: "white",
            marginTop: "95%",
            width: "80%",
            marginLeft: "15%",
          }}
        />
        <div
          style={{
            position: "absolute",
            borderLeftWidth: 2,
            borderColor: "white",
            marginTop: "6%",
            height: "92%",
            marginLeft: "93%",
          }}
        />
        <div
          style={{
            position: "absolute",
            borderLeftWidth: 2,
            borderColor: "white",
            marginTop: "6%",
            height: "87%",
            marginLeft: "7%",
          }}
        />
        <div
          style={{
            position: "absolute",
            borderLeftWidth: 2,
            borderColor: "white",
            marginTop: "2%",
            height: "50%",
            marginLeft: "3%",
          }}
        />
        <div
          style={{
            position: "absolute",
            borderBottomWidth: 2,
            borderColor: "white",
            marginTop: "2%",
            width: "60%",
            marginLeft: "3%",
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "80%",
            height: "80%",
            backgroundColor: "#1279B3",
            marginTop: "10%",
            marginLeft: "10%",
            minHeight: "240px",
          }}
        >
          <iframe
            ref={iframeRef}
            src={`https://player.vimeo.com/video/${VIMEO_VIDEO_ID}?badge=0&autopause=0&player_id=0&app_id=58479`}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute w-[100%] h-[100%] top-0 left-0"
            title="Rent-to-own with Keyzy"
            suppressHydrationWarning
            loading="lazy"
          />

          {!isPlaying && (
            <div
              className={`absolute w-[100%] h-[100%] bg-[#1279B3] flex items-center justify-center cursor-pointer transition-opacity duration-500 hover:bg-opacity-[99%] group ${
                isFading ? "opacity-0" : "opacity-100"
              }`}
              onClick={handlePlayVideo}
            >
              <div className="text-center text-white">
                <div className="w-full mt-8 flex justify-center">
                  <div className="w-[80%]">
                    <Image
                      src="/how-it-works/keyzy-logo-white.svg"
                      alt="Keyzy Logo"
                      width={400}
                      height={100}
                      className="w-full h-auto"
                    />
                  </div>
                </div>
                <div className="text-lg md:text-xl font-semibold mb-2 hover:cursor-pointer">
                  Watch video
                  <span className="text-lg ml-2 transition-all duration-300 group-hover:ml-4">
                    ▶
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Dog image for large screen sizes */}
      <div className="hidden lg:block lg:mt-[72px] xl:mt-[45px] w-full xl:-ml-20 ">
        <Image
          src="/how-it-works/desktop-dog.svg"
          alt="Dog"
          width={455}
          height={61}
          className="w-full h-auto"
        />
      </div>
      {/* Dog image for medium screen sizes */}
      <div className="hidden md:block mt-8 bottom-0 lg:hidden ">
        <Image
          src="/how-it-works/mobile-dog.svg"
          alt="Dog"
          width={400}
          height={61}
          className="w-full h-auto"
        />
      </div>
      {/* Dog image for smal screen sizes */}
      <div className="md:hidden mt-4 w-full flex justify-center">
        <Image
          src="/how-it-works/mobile-dog.svg"
          alt="Dog"
          width={332}
          height={45}
          className="w-full h-auto"
        />
      </div>
    </div>
  );
};

export default VideoCard;
